import { IconV2 } from '@abtasty/design-system';
import { styled, useTheme } from 'styled-components';

const Icon = styled(IconV2)<{ $expanded?: boolean }>`
  cursor: pointer;
  pointer-events: none;
  transition: 0.5s;
  transform: ${({ $expanded }) => ($expanded ? 'rotate(-180deg)' : 'rotate(0deg)')};
  overflow: visible !important;
`;

type ExpandIconProps = { expanded?: boolean };
export function ExpandIcon({ expanded }: ExpandIconProps) {
  const theme = useTheme();

  return (
    <Icon
      icon="caretDown"
      color={theme.dec.color.primary.default.fg.minimal}
      data-testid="expand-arrow"
      size={24}
      $expanded={expanded}
    />
  );
}
